import { createSelector } from 'reselect';

const selectsubscriptions = (state: any) => state.subscriptions;


export const selectsubscriptionsCurrentItem = createSelector([selectsubscriptions], (subscriptions) => subscriptions.current);

export const selectsubscriptionsListItems = createSelector([selectsubscriptions], (subscriptions) => subscriptions.list);

export const selectItemById = (itemId: any) =>
    createSelector(selectsubscriptionsListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectsubscriptionsQueryItems = createSelector([selectsubscriptions], (subscriptions) => subscriptions.query);

export const selectsubscriptionsCreatedItem = createSelector([selectsubscriptions], (subscriptions) => subscriptions.create);

export const selectsubscriptionsUpdatedItem = createSelector([selectsubscriptions], (subscriptions) => subscriptions.update);

export const selectsubscriptionsReadItem = createSelector([selectsubscriptions], (subscriptions) => subscriptions.read);

export const selectsubscriptionsDeletedItem = createSelector([selectsubscriptions], (subscriptions) => subscriptions.delete);

export const selectsubscriptionsSearchedItems = createSelector([selectsubscriptions], (subscriptions) => subscriptions.search);

export const selectsubscriptionsItemsCount = createSelector([selectsubscriptions], (subscriptions) => subscriptions.count);

export const selectsubscriptionsItemsFilter = createSelector([selectsubscriptions], (subscriptions) => subscriptions.filter);